export default [
  {
    "id": "404",
    "name": "not-found",
    "path": "/404/"
  },
  {
    "id": "500",
    "name": "error",
    "path": "/500/"
  },
  {
    "id": "404",
    "name": "internal-not-found-page",
    "path": "/error-404/"
  },
  {
    "id": "offers",
    "name": "offers",
    "path": "/:slug/m/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "home",
    "name": "home",
    "path": "/"
  },
  {
    "id": "product",
    "name": "produto",
    "path": "/:slug/p/:productId/:categoryId/:subCategoryId/inapp/"
  },
  {
    "id": "product",
    "name": "produto",
    "path": "/:slug/p/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "product-id",
    "name": "produto-id",
    "path": "/p/:productId/"
  },
  {
    "id": "report",
    "name": "denuncie",
    "path": "/denuncie/:productId/"
  },
  {
    "id": "report-confirmation",
    "name": "denuncie-confirmacao",
    "path": "/denuncie/confirmacao/"
  },
  {
    "id": "review-list",
    "name": "review-list",
    "path": "/review/:productId/:slug/:categoryId/:subCategoryId/"
  },
  {
    "id": "rate-product",
    "name": "rate-product",
    "path": "/r/:slug/:productId/:categoryId/:subCategoryId/"
  }
]
